export default {
  toasts: {
    load_error: 'Impossibile caricare la configurazione dei pagamenti',
    rails_saved: 'Canali di pagamento salvati',
    gateway_registered: 'Gateway registrato',
    redact_failed: 'Impossibile eliminare il gateway',
    gateway_redacted: 'Gateway eliminato',
    sca_provisioned: 'Registrazione 3DS2 creata',
    company_assigned: 'Ristorante assegnato',
    default_set: 'Gateway predefinito impostato: i nuovi ristoranti verranno assegnati automaticamente ad esso',
    default_failed: 'Impossibile impostare il gateway predefinito',
    primary_switched: 'Gateway principale passato a {{gateway}}',
    primary_switch_failed: 'Impossibile cambiare il gateway principale',
  },
  custody: {
    title: 'Chi elabora i pagamenti',
    description:
      "Deciso una volta, al primo salvataggio del canale, e bloccato in seguito: con il proprio gateway il partner detiene i fondi; sull'account Adyen di FoodAmigos, FoodAmigos li detiene e paga mensilmente la quota del partner.",
    options: {
      provider: 'Gateway proprio del partner',
      platform: 'FoodAmigos elabora i pagamenti',
    },
    locked_notice: 'Bloccato su "{{custodian}}" dalla configurazione dei pagamenti — non può essere modificato.',
    pick_first: 'Scegli prima chi elabora i pagamenti.',
    lock_confirm: {
      title: 'Bloccare i pagamenti su “{{custodian}}”?',
      description:
        'Salvando ora si decide chi gestisce i fondi di questo partner, e non può essere annullato — né qui, né dal supporto. Il metodo di pagamento può ancora essere cambiato in seguito; chi elabora i pagamenti no.',
      confirm: 'Blocca e salva',
    },
  },
  rails: {
    title: 'Canale di pagamento',
    description:
      'Su quale processore opera questo partner — uno alla volta. I ristoranti possono passare solo al canale selezionato qui, e un canale non può essere sostituito finché alcuni ristoranti lo usano ancora per gli addebiti.',
    save: 'Salva canale',
    multiple_warning:
      'Questo partner opera ancora su più canali ({{rails}}). Salvando si mantiene solo quello selezionato sopra; gli altri vengono rimossi, e la modifica viene rifiutata se un ristorante addebita ancora su uno di essi.',
    options: {
      stripe: 'Stripe',
      adyen: 'Adyen',
      spreedly: 'Gateway locale tramite Spreedly',
    },
    platform_stripe_unavailable: 'Stripe sugli account FoodAmigos non è ancora disponibile.',
    platform_custody_notice: 'Non disponibile quando FoodAmigos elabora i pagamenti.',
    provider_custody_adyen_notice:
      'Non disponibile quando il partner usa un proprio gateway: Adyen è il circuito di elaborazione FoodAmigos.',
  },
  spreedly_section_title: 'Configurazione Spreedly',
  gateways: {
    title: 'Gateway',
    description: "I conti PSP del partner. L'intero addebito viene liquidato all'acquirer del gateway selezionato.",
    register: 'Registra gateway',
    empty: 'Nessun gateway registrato',
    columns: {
      gateway: 'Gateway',
      status: 'Stato',
      sca: '3DS2',
      companies: 'Ristoranti',
    },
    statuses: {
      active: 'Attivo',
      redacted: 'Eliminato',
    },
    sca: {
      sandbox: 'Sandbox 3DS2',
      live: '3DS2 live',
      none: 'Nessun 3DS2',
    },
    default_tag: 'Predefinito',
    actions: {
      make_default: 'Imposta come predefinito',
      check: 'Esegui controllo…',
      sca_provision: 'Configura 3DS2…',
      sca_manage: 'Registrazione 3DS2…',
      redact: 'Elimina gateway',
    },
  },
  redact_confirm: {
    title: 'Eliminare {{gateway}}?',
    description:
      "Le credenziali vengono eliminate su Spreedly e non possono essere ripristinate. {{count}} ristorante/i assegnato/i eseguono ancora addebiti tramite questo gateway: mentre ce ne sono assegnati, l'eliminazione viene rifiutata e ti viene chiesto di confermare di nuovo.",
    redact: 'Elimina',
    force_title: 'Eliminare comunque {{gateway}}?',
    force_description:
      '{{count}} ristorante/i sono ancora assegnati a questo gateway. Eliminandolo ora, il checkout verrà rifiutato finché ciascuno non sarà assegnato a un altro gateway. Questa azione non può essere annullata.',
    force_redact: 'Elimina comunque',
  },
  companies: {
    title: 'Ristoranti',
    description:
      'Il processore utilizzato da ogni ristorante per gli addebiti e la relativa assegnazione al gateway Spreedly.',
    empty: 'Nessun ristorante',
    no_gateway: 'Nessuno',
    unassigned: 'Non assegnato',
    // The default gateway is assigned at creation and never fails the creation —
    // so a restaurant can end up unassigned with the reason only in the log.
    assignment_error_label: 'Assegnazione automatica non riuscita',
    assign: 'Assegna',
    reassign: 'Riassegna',
    columns: {
      restaurant: 'Ristorante',
      primary_gateway: 'Gateway principale',
      spreedly: 'Gateway Spreedly',
    },
    switch_primary_to: 'Passa a {{gateway}}',
    assign_modal: {
      title: 'Assegna {{company}} a un gateway',
      assign: 'Assegna',
      gateway: 'Gateway',
      make_primary: 'Rendi anche Spreedly il gateway principale',
      make_primary_hint: 'Gli addebiti passano tramite Spreedly solo mentre è il gateway principale.',
    },
  },
  register_modal: {
    title: 'Registra un gateway',
    register: 'Registra',
    gateway_type: 'Tipo di gateway',
    gateway_type_placeholder: 'Cerca nel catalogo di Spreedly…',
    auth_mode: 'Modalità di autenticazione',
    no_credentials: 'Questo tipo di gateway non richiede credenziali (sandbox Spreedly).',
    description: 'Descrizione',
    description_placeholder: 'es. Acme Eats — Braintree EUR',
    acquirer_merchant_id: 'ID commerciante acquirer',
    acquirer_hint: 'Opzionale — obbligatorio insieme al MCC',
    mcc: 'MCC',
    mcc_hint: '4 cifre, es. 5812',
    make_default: 'Usa come predefinito del partner',
    make_default_hint:
      "I nuovi ristoranti del partner e quelli senza ancora un gateway vengono associati a questo. Lascia deselezionato se è l'acquirer di un singolo ristorante.",
  },
  sca_modal: {
    title: 'Registrazione 3DS2 — {{gateway}}',
    provision: 'Configura',
    irreversible_warning:
      "Irreversibile: né il profilo commerciante né il provider SCA possono essere modificati o eliminati in seguito. Un BIN dell'acquirer errato emerge solo al momento dell'addebito. Verifica ogni valore con la banca acquirer prima di procedere alla configurazione.",
    already_provisioned:
      "Già configurato (token provider {{token}}). Configurare di nuovo restituisce la registrazione esistente, a meno che non sia attivata l'opzione Ricrea.",
    type: {
      label: 'Tipo di provider',
      hint: "«Test» simula gli esiti dell'autenticazione ed è rifiutato in produzione.",
      test: 'Test (sandbox SCA)',
      live: 'Live (Spreedly 3DS2 Global)',
    },
    country: {
      hint: 'Il paese in cui la banca acquirer ha registrato questo merchant — non necessariamente quello in cui il partner è incorporato. Si applica a tutti i circuiti di carte qui sotto.',
      differs_warning:
        "Non è il paese del partner ({{country}}). Correggilo se l'acquirer ha registrato il merchant altrove; in caso contrario verificalo, perché un profilo merchant non può essere modificato una volta creato.",
    },
    network_placeholder: 'Rete carta',
    add_network: 'Aggiungi circuito carta',
    networks: {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
      discover: 'Discover',
      diners: 'Diners',
      jcb: 'JCB',
      dankort: 'Dankort',
      union_pay: 'UnionPay',
      cartes_bancaires: 'Cartes Bancaires',
    },
    fields: {
      acquirer_merchant_id: 'ID commerciante acquirer',
      acquirer_bin: 'BIN acquirer',
      mcc: 'MCC',
      merchant_name: 'Nome commerciante',
      country_code: 'Paese (ISO-2)',
      merchant_url: 'URL commerciante',
    },
    recreate: {
      label: 'Ricrea la registrazione',
      hint: 'Abbandona definitivamente il profilo commerciante e il provider SCA attuali e ne crea di nuovi.',
    },
  },
  check_modal: {
    title: 'Verifica gateway — {{gateway}}',
    run: 'Avvia verifica',
    done: 'Fatto',
    failed: 'Impossibile eseguire la verifica.',
    types: {
      verify: 'Verifica (nessun movimento di denaro)',
      test_payment: 'Pagamento di prova',
    },
    verify_unsupported: 'Questo tipo di gateway non supporta la verifica — esegui invece un pagamento di prova.',
    test_payment_warning:
      "Viene effettuato un addebito reale su un gateway live e rimborsato immediatamente. Su gateway in mercati SCA, l'emittente potrebbe rifiutare il probe non-3DS — ciò dimostra comunque che le credenziali hanno raggiunto l'acquirer.",
    amount: 'Importo',
    amount_help: 'Tra 1,00 e 5,00',
    check_passed: 'Verifica superata',
    check_failed: 'Verifica non riuscita — vedi i passaggi sottostanti',
    legs: {
      verify: 'Verifica',
      purchase: 'Addebito',
      credit: 'Rimborso',
    },
    leg_passed: 'Superato',
    leg_failed: 'Non riuscito',
  },
  card_fields: {
    script_failed: 'Impossibile caricare lo script Spreedly. Controlla la rete e riprova.',
    full_name: 'Nome del titolare',
    number: 'Numero carta',
    expiry: 'Scadenza',
    cvv: 'CVV',
  },
};
